export const footerCopy = {
  en: {
    affiliateTitle: "Earn with Marstick Affiliate Program",
    affiliateText: "Share Marstick with other sailors and earn your premium content right away!",
    joinNow: "Join Now",
    brandText: "The global platform for sailors. Navigate with confidence, learn seamlessly, and connect with the sailing community.",
    newsletterTitle: "Stay Updated",
    newsletterText: "Get sailing tips, safety updates, and feature announcements",
    emailPlaceholder: "your@email.com",
    subscribe: "Subscribe",
    rights: "All rights reserved. Built for sailors, by sailors.",
    cookieSettings: "Cookie settings",
    madeWith: "Made with",
    madeBy: "by the Marstick team",
    groups: {
      Product: "Product", Discover: "Discover", Legal: "Legal",
      "Premium Tools": "Premium Tools", "AI Skipper": "AI Skipper", "Fleet Operations": "Fleet Operations", "Skipper Tools": "Skipper Tools",
      Marinas: "Marinas", Routes: "Routes", Ports: "Ports", Regulations: "Regulations", "Nautical Glossary": "Nautical Glossary",
      "Privacy Policy": "Privacy Policy", "Terms & Conditions": "Terms & Conditions", "Cookie Policy": "Cookie Policy", Contact: "Contact"
    }
  },
  ru: {
    affiliateTitle: "Зарабатывайте с партнёрской программой Marstick",
    affiliateText: "Делитесь Marstick с другими моряками и получайте 20% регулярной комиссии",
    joinNow: "Присоединиться",
    brandText: "Глобальная платформа для яхтсменов. Навигируйте уверенно, учитесь легко и общайтесь с морским сообществом.",
    newsletterTitle: "Будьте в курсе",
    newsletterText: "Получайте советы по плаванию, обновления безопасности и новости функций",
    emailPlaceholder: "your@email.com",
    subscribe: "Подписаться",
    rights: "Все права защищены. Создано моряками для моряков.",
    cookieSettings: "Настройки cookie",
    madeWith: "Сделано с",
    madeBy: "командой Marstick",
    groups: {}
  },
  he: {
    affiliateTitle: "הרוויחו עם תוכנית השותפים של Marstick",
    affiliateText: "שתפו את Marstick עם שייטים אחרים וקבלו 20% עמלה חוזרת",
    joinNow: "הצטרפו עכשיו",
    brandText: "הפלטפורמה הגלובלית לשייטים. נווטו בביטחון, למדו בקלות והתחברו לקהילת השייט.",
    newsletterTitle: "הישארו מעודכנים",
    newsletterText: "קבלו טיפים לשייט, עדכוני בטיחות והודעות על פיצ׳רים",
    emailPlaceholder: "your@email.com",
    subscribe: "הרשמה",
    rights: "כל הזכויות שמורות. נבנה עבור שייטים, על ידי שייטים.",
    cookieSettings: "הגדרות עוגיות",
    madeWith: "נוצר באהבה",
    madeBy: "על ידי צוות Marstick",
    groups: {
      Product: "מוצר", Discover: "גילוי", Legal: "משפטי",
      "Premium Tools": "כלי פרימיום", "AI Skipper": "סקיפר AI", "Fleet Operations": "ניהול צי", "Skipper Tools": "כלי סקיפר",
      Marinas: "מרינות", Routes: "מסלולים", Ports: "נמלים", Regulations: "תקנות", "Nautical Glossary": "מילון ימי",
      "Privacy Policy": "מדיניות פרטיות", "Terms & Conditions": "תנאי שימוש", "Cookie Policy": "מדיניות עוגיות", Contact: "צור קשר"
    }
  },
  el: {
    affiliateTitle: "Κερδίστε με το πρόγραμμα συνεργατών Marstick",
    affiliateText: "Μοιραστείτε το Marstick με άλλους ναυτικούς και κερδίστε 20% επαναλαμβανόμενες προμήθειες",
    joinNow: "Εγγραφή",
    brandText: "Η παγκόσμια πλατφόρμα για ναυτικούς. Πλοηγηθείτε με σιγουριά, μάθετε εύκολα και συνδεθείτε με την κοινότητα.",
    newsletterTitle: "Μείνετε ενημερωμένοι",
    newsletterText: "Λάβετε συμβουλές ιστιοπλοΐας, ενημερώσεις ασφαλείας και νέα λειτουργιών",
    emailPlaceholder: "your@email.com",
    subscribe: "Εγγραφή",
    rights: "Με επιφύλαξη παντός δικαιώματος. Φτιαγμένο για ναυτικούς, από ναυτικούς.",
    cookieSettings: "Ρυθμίσεις cookies",
    madeWith: "Φτιαγμένο με",
    madeBy: "από την ομάδα Marstick",
    groups: {}
  },
  es: {
    affiliateTitle: "Gana con el programa de afiliados de Marstick",
    affiliateText: "Comparte Marstick con otros navegantes y gana un 20% de comisiones recurrentes",
    joinNow: "Únete ahora",
    brandText: "La plataforma global para navegantes. Navega con confianza, aprende sin esfuerzo y conecta con la comunidad náutica.",
    newsletterTitle: "Mantente al día",
    newsletterText: "Recibe consejos de navegación, actualizaciones de seguridad y novedades",
    emailPlaceholder: "tu@email.com",
    subscribe: "Suscribirse",
    rights: "Todos los derechos reservados. Creado para navegantes, por navegantes.",
    cookieSettings: "Configuración de cookies",
    madeWith: "Hecho con",
    madeBy: "por el equipo de Marstick",
    groups: {
      Product: "Producto", Discover: "Descubrir", Legal: "Legal",
      "Premium Tools": "Herramientas premium", "AI Skipper": "AI Skipper", "Fleet Operations": "Operaciones de flota", "Skipper Tools": "Herramientas del patrón",
      Marinas: "Marinas", Routes: "Rutas", Ports: "Puertos", Regulations: "Regulaciones", "Nautical Glossary": "Glosario náutico",
      "Privacy Policy": "Política de privacidad", "Terms & Conditions": "Términos y condiciones", "Cookie Policy": "Política de cookies", Contact: "Contacto"
    }
  },
  it: {
    affiliateTitle: "Guadagna con il programma affiliati Marstick",
    affiliateText: "Condividi Marstick con altri velisti e guadagna il 20% di commissioni ricorrenti",
    joinNow: "Iscriviti ora",
    brandText: "La piattaforma globale per i velisti. Naviga con fiducia, impara facilmente e connettiti con la comunità nautica.",
    newsletterTitle: "Rimani aggiornato",
    newsletterText: "Ricevi consigli di navigazione, aggiornamenti sulla sicurezza e novità",
    emailPlaceholder: "your@email.com",
    subscribe: "Iscriviti",
    rights: "Tutti i diritti riservati. Creato per velisti, da velisti.",
    cookieSettings: "Impostazioni cookie",
    madeWith: "Realizzato con",
    madeBy: "dal team Marstick",
    groups: {}
  },
  fr: {
    affiliateTitle: "Gagnez avec le programme d’affiliation Marstick",
    affiliateText: "Partagez Marstick avec d’autres marins et gagnez 20% de commissions récurrentes",
    joinNow: "Rejoindre",
    brandText: "La plateforme mondiale pour les marins. Naviguez en confiance, apprenez facilement et rejoignez la communauté nautique.",
    newsletterTitle: "Restez informé",
    newsletterText: "Recevez des conseils de navigation, des alertes sécurité et les nouveautés",
    emailPlaceholder: "votre@email.com",
    subscribe: "S’abonner",
    rights: "Tous droits réservés. Conçu pour les marins, par des marins.",
    cookieSettings: "Paramètres des cookies",
    madeWith: "Fait avec",
    madeBy: "par l’équipe Marstick",
    groups: {
      Product: "Produit", Discover: "Découvrir", Legal: "Légal",
      "Premium Tools": "Outils premium", "AI Skipper": "AI Skipper", "Fleet Operations": "Opérations de flotte", "Skipper Tools": "Outils skipper",
      Marinas: "Marinas", Routes: "Routes", Ports: "Ports", Regulations: "Réglementation", "Nautical Glossary": "Glossaire nautique",
      "Privacy Policy": "Politique de confidentialité", "Terms & Conditions": "Conditions générales", "Cookie Policy": "Politique de cookies", Contact: "Contact"
    }
  },
  ar: {
    affiliateTitle: "اربح مع برنامج شركاء Marstick",
    affiliateText: "شارك Marstick مع البحارة الآخرين واكسب عمولات متكررة بنسبة 20%",
    joinNow: "انضم الآن",
    brandText: "المنصة العالمية للبحارة. أبحر بثقة، تعلّم بسهولة، وتواصل مع مجتمع الإبحار.",
    newsletterTitle: "ابقَ على اطلاع",
    newsletterText: "احصل على نصائح الإبحار وتحديثات السلامة وأخبار الميزات",
    emailPlaceholder: "your@email.com",
    subscribe: "اشتراك",
    rights: "جميع الحقوق محفوظة. صُمم للبحارة، بواسطة البحارة.",
    cookieSettings: "إعدادات ملفات تعريف الارتباط",
    madeWith: "صُنع بحب",
    madeBy: "بواسطة فريق Marstick",
    groups: {}
  },
  de: {
    affiliateTitle: "Verdiene mit dem Marstick-Partnerprogramm",
    affiliateText: "Teile Marstick mit anderen Seglern und verdiene 20% wiederkehrende Provisionen",
    joinNow: "Jetzt beitreten",
    brandText: "Die globale Plattform für Segler. Navigiere sicher, lerne mühelos und verbinde dich mit der Segel-Community.",
    newsletterTitle: "Bleib informiert",
    newsletterText: "Erhalte Segeltipps, Sicherheitsupdates und Funktionsneuheiten",
    emailPlaceholder: "deine@email.com",
    subscribe: "Abonnieren",
    rights: "Alle Rechte vorbehalten. Von Seglern für Segler gebaut.",
    cookieSettings: "Cookie-Einstellungen",
    madeWith: "Gemacht mit",
    madeBy: "vom Marstick-Team",
    groups: {}
  },
  tr: {
    affiliateTitle: "Marstick Ortaklık Programı ile kazanın",
    affiliateText: "Marstick’i diğer denizcilerle paylaşın ve %20 tekrarlayan komisyon kazanın",
    joinNow: "Şimdi katıl",
    brandText: "Denizciler için küresel platform. Güvenle seyredin, kolayca öğrenin ve yelken topluluğuyla bağlantı kurun.",
    newsletterTitle: "Güncel kalın",
    newsletterText: "Yelken ipuçları, güvenlik güncellemeleri ve özellik duyuruları alın",
    emailPlaceholder: "your@email.com",
    subscribe: "Abone ol",
    rights: "Tüm hakları saklıdır. Denizciler için, denizciler tarafından geliştirildi.",
    cookieSettings: "Çerez ayarları",
    madeWith: "Sevgiyle yapıldı",
    madeBy: "Marstick ekibi tarafından",
    groups: {}
  },
  pt: {
    affiliateTitle: "Ganhe com o programa de afiliados Marstick",
    affiliateText: "Partilhe o Marstick com outros velejadores e ganhe 20% de comissões recorrentes",
    joinNow: "Participar agora",
    brandText: "A plataforma global para velejadores. Navegue com confiança, aprenda facilmente e ligue-se à comunidade náutica.",
    newsletterTitle: "Mantenha-se atualizado",
    newsletterText: "Receba dicas de navegação, atualizações de segurança e novidades",
    emailPlaceholder: "seu@email.com",
    subscribe: "Subscrever",
    rights: "Todos os direitos reservados. Criado para velejadores, por velejadores.",
    cookieSettings: "Definições de cookies",
    madeWith: "Feito com",
    madeBy: "pela equipa Marstick",
    groups: {}
  },
  zh: {
    affiliateTitle: "通过 Marstick 联盟计划赚取收益",
    affiliateText: "与其他水手分享 Marstick，赚取 20% 的持续佣金",
    joinNow: "立即加入",
    brandText: "面向水手的全球平台。自信导航，轻松学习，并连接航海社区。",
    newsletterTitle: "保持更新",
    newsletterText: "获取航海技巧、安全更新和功能公告",
    emailPlaceholder: "your@email.com",
    subscribe: "订阅",
    rights: "版权所有。由水手打造，为水手服务。",
    cookieSettings: "Cookie 设置",
    madeWith: "用心制作",
    madeBy: "Marstick 团队",
    groups: {}
  }
};

export function getFooterCopy(language) {
  const fallback = footerCopy.en;
  const copy = footerCopy[language] || fallback;
  return { ...fallback, ...copy, groups: { ...fallback.groups, ...(copy.groups || {}) } };
}